import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { isNullOrUndefined } from '../../shared/utils/helper.utils';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import * as AuthSelectors from '../store/auth/auth.selectors';
import {
  MINDPLAY_EMPLOYEE_ROLES, NO_EMPLOYEE_HEADERS,
  SCHOOL_ID_HEADER,
  USER_GROUP_ORGANIZATION_ID_HEADER,
} from '../constants/constants';
import { HttpClientType } from '../studio-http-client/http-client-type';

export function additionalEmployeeHeadersInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const clientTypeString = req.headers.get('clientType');

  // If request doesn't have client type - skip
  if (isNullOrUndefined(clientTypeString)) {
    return next(req);
  }

  const clientType = +clientTypeString as HttpClientType;

  // If request doesn't point to LS - skip
  if (clientType !== HttpClientType.LightSail) {
    return next(req);
  }

  const schoolIdHeader = req.headers.get(SCHOOL_ID_HEADER);
  const userGroupOrganizationIdHeader = req.headers.get(USER_GROUP_ORGANIZATION_ID_HEADER);

  // If schoolId or ugoId already added - skip
  if (schoolIdHeader || userGroupOrganizationIdHeader) {
    return next(req);
  }

  // if noEmployeeHeaders is present - skip
  const noEmployeeHeaders = req.headers.get(NO_EMPLOYEE_HEADERS);
  if (noEmployeeHeaders) {
    return next(req.clone({
      headers: req.headers.delete(NO_EMPLOYEE_HEADERS),
    }));
  }

  const store = inject(Store);

  const mpUserRole = store.selectSignal(AuthSelectors.selectMpUserRole)();

  // If not MP Employee - skip
  if (!MINDPLAY_EMPLOYEE_ROLES.includes(mpUserRole)) {
    return next(req);
  }

  const schoolId = store.selectSignal(AuthSelectors.selectSchoolId)();
  const userGroupOrganizationId = store.selectSignal(AuthSelectors.selectUserGroupOrgId)();

  // If no schoolId or ugoId in the store - skip
  if (isNullOrUndefined(schoolId) || isNullOrUndefined(userGroupOrganizationId)) {
    return next(req);
  }

  const headers = req.headers
    .append(SCHOOL_ID_HEADER, schoolId)
    .append(USER_GROUP_ORGANIZATION_ID_HEADER, userGroupOrganizationId);

  return next(
    req.clone({
      headers,
    })
  );
}
